import { useContext } from "react";
import { ResubmitRequestContext } from "../context";

export function useResubmitRequestContext() {
  const { state, dispatch } = useContext(ResubmitRequestContext);
  return { state, dispatch };
}
